import React, { forwardRef } from "react";
import Blog from ".";
import Image from "../Image";
import styled from "styled-components";
import { Button } from "react-bootstrap";
import { IBlogProps } from "./";
import classNames from 'classnames';

const FeaturedArticleContainer = styled.div`
    @media(min-width:992px) {
        .image-container {
            min-width: 480px;
        }
    }
`;

const FeaturedArticle = forwardRef((props: IBlogProps, ref: any) => {
    const {
        tags,
        title,
        description,
        href,
        src,
        alt,
        timestamp,
        dateType,
        cmsId,
        editorClassObj,
    } = props;

    return (
        <div className="px-2 px-xl-3 mb-5">
            <div className="col-12">
                <div className="mx-0 mt-5">
                    <FeaturedArticleContainer ref={ref} data-id={cmsId} className={classNames(editorClassObj, "row")}>
                        <div className="col-12 col-lg-7 px-lg-0 mr-lg-5 mr-0 image-container">
                            <a data-test-id="featured-article-image-link" href={href}>
                                <Image loading="lazy" dataTestId="featured-article-image" src={src} alt={alt} />
                            </a>
                        </div>
                        <div className="col-12 col-lg-4 col-xl-4 px-3 px-lg-0 mt-lg-4 mt-0">
                            <Blog
                                testIdPrefix="featured-article-"
                                description={description}
                                headerAs="h4"
                                headerClassName="mt-lg-0 mt-4"
                                title={title}
                                tags={tags}
                                timestamp={timestamp}
                                href={href}
                                dateType={dateType}
                                isMainArticle={false}
                            />
                            <div className="text-center w-100 mt-4">
                                <Button data-test-id="featured-article-button" variant="primary" className="w-100 py-2 continue-reading" href={href}>Continue Reading</Button>
                            </div>
                        </div>
                    </FeaturedArticleContainer>
                </div>
            </div>
        </div>
    );
});

export default FeaturedArticle;
